import React from 'react'
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const ConverionRateError = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('attention')} !</h4>
            {props.data.map((value, key) => (
                <>
                    <p className="popup-error-msg">{props.t(Object.values(value)[0]?.replace(/^api_messages\./, ''))}</p>
                </>
            ))}
        </div>
    )
}

ConverionRateError.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ConverionRateError)
